import { QUERY_PARAMS } from 'utils/constants';
import getQueryParam from 'utils/getQueryParam';

const fallbackLocale = import.meta.env.VITE_LOCALE_FALLBACK || 'en-GB';

export const getLocaleFromPath = (): string | null => {
  const match = window.location.pathname.match(/\/([a-z]{2})\/([a-z]{2})(?:\/|#|\?)/);
  return match ? `${match[2]}-${match[1].toUpperCase()}` : null;
};

/**
 * Parses the locale from the query parameters or path and returns it if it exists.
 */
export const getLocale = (): string => {
  const locale = getQueryParam(QUERY_PARAMS.LOCALE) || getLocaleFromPath();

  if (locale) {
    return locale;
  }

  return fallbackLocale;
};
export const getLanguage = (locale: string): string => {
  const split = locale.split('-')?.[0];
  if (!split) {
    // Let error handler handle this.
    return locale;
  }
  return locale.split('-')?.[0];
};

export const getCountry = (locale: string): string => {
  const split = locale.split('-')?.[1];
  if (!split) {
    // Let error handler handle this.
    return locale;
  }
  return locale.split('-')?.[1];
};
